import { useFormContext } from "react-hook-form";
import {
  CONTEXT_PLACEHOLDERS,
  CONTROL_PLACEHOLDERS,
  IFormPlaceholder,
} from "./placeholders";
import styles from "./FormPlaceholderPalette.module.scss";

interface IFormPlaceholderPaletteProps {
  fieldName: string;
}

export const FormPlaceholderPalette = ({
  fieldName,
}: IFormPlaceholderPaletteProps) => {
  const { getValues, setValue } = useFormContext();

  const insert = (token: string) => {
    const current: string = getValues(fieldName) ?? "";
    const needsSpace =
      current.length > 0 && !current.endsWith(" ") && !current.endsWith("\n");

    setValue(fieldName, `${current}${needsSpace ? " " : ""}${token}`, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const renderChips = (placeholders: IFormPlaceholder[]) =>
    placeholders.map((placeholder) => (
      <button
        type="button"
        key={placeholder.token}
        className={styles.chip}
        onClick={() => insert(placeholder.token)}
        title={placeholder.token}
      >
        {placeholder.label}
      </button>
    ));

  return (
    <div className={styles.root}>
      <div className={styles.group}>
        <div className={styles.group_title}>
          Данни (попълват се автоматично)
        </div>
        <div className={styles.chips}>{renderChips(CONTEXT_PLACEHOLDERS)}</div>
      </div>
      <div className={styles.group}>
        <div className={styles.group_title}>Полета и форматиране</div>
        <div className={styles.chips}>{renderChips(CONTROL_PLACEHOLDERS)}</div>
      </div>
    </div>
  );
};
